const _moduleNames: string[] = [];
const _moduleNamesMap: Record<string, boolean> = {};

/** register a new module */
export function addModule(moduleName: string): void {
	if (!_moduleNamesMap[moduleName]) {
		_moduleNames.push(moduleName);
		_moduleNamesMap[moduleName] = true;
	}
}

/** return registered module names */
export function getModuleNames(): string[] {
	return _moduleNames;
}

/** true if the module is registered */
export function hasModule(moduleName: string): boolean {
	return _moduleNamesMap[moduleName];
}

/** return true if the comma-separated list of modules is registered */
export function hasModules(modules: string): boolean {
	return modules.split(",").every(hasModule);
}

/** register module names */
export function setModuleNames(moduleNames: string[]): void {
	moduleNames.forEach(addModule);
}
